export default {
  user: {
    ID: '用户ID',
    username: '用户名',
    addressList: '我的地址',
    cart: '我的购物车',
    orderList: '我的订单',
    clearCache:'您的缓存资料已被清除，并将会登出！',
    logout:"登出",
    editPassword: '修改密码',
    confirm: '确认',
    contact: '联络客户服务主任'
  },
  credit: {
    title: 'KOL 热购',
    myCredit: '我的积分',
    editPaymentMessage: '修改收款信息',
    history: '历史记录',
    credit: '积分',
    pay: '付款',
    buy: '购买',
    commission: '积分奖赏',
    refund: '退款',
    orderNumber: '订单号码:',
    noMoreData: '没有更多数据',
    receiveType: '收款类型', 
    wechat: '微信',
    transfer: '转帐',
    receiptName: '收款人',
    receiptNumber: '收款号码',
    enterNumber: '请输入收款微信／银行卡号',
    beforeUploadConfirm: '－ 于上传资料前，请确保收款类型，收款人以及号码正确无误',
    upload: '上传',
    successAlert: '你已成功更改收款信息',
    failAlert: '请确保上述资料已填妥',
    remind: '提醒'
  },
  password: {
    oldPassword: '旧密码',
    newPassword: '新密码',
    enterOldPassword: '请在此输入你的旧密码',
    enterNewPassword: '请在此输入你的新密码',
    confirmPassword: '确认新密码',
    remind: '－ 请确保密码须为6个或以上位字元，并建议包含大写和小写字母以及数字',
    editPassword: '修改密码',
    successAlert: '你已成功更改密码',
    failAlert: '请确保你已填写所有资料，及新的密码与确认密码相乎',
  }
}


// WEBPACK FOOTER //
// ./src/Account/langs/zh_cn/index.js